import { DropdownItem } from '@/main/store/@types/dropdown.d';
import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		NdakcecheckPzn: [] as DropdownItem[],
		Sort2ddSmNd: [] as DropdownItem[],
		Sort2ddSmPp: [] as DropdownItem[],
		NvkonfigstylPzn: [] as DropdownItem[],
		DokladnrStylPzn: [] as DropdownItem[],
		QrCodeRezimPzn: [] as DropdownItem[],
		MenaId: [] as DropdownItem[],
		KalkulacePzn: [] as DropdownItem[],
		KalkgarpcndPzn: [] as DropdownItem[],
		KalkgarpcppPzn: [] as DropdownItem[],
		KalkdrmatprePzn: [] as DropdownItem[],
		AudatexCommiVer: [] as DropdownItem[],
		KalkorigtxtndPzn: [] as DropdownItem[],
		KalkorigtxtppPzn: [] as DropdownItem[],
		KalklakdruhprePzn: [] as DropdownItem[],
	},
	edit: {
		AphlasMimoPrp: null as number | null,
		AudatexCommiVer: null as string | null,
		AudatexPassw: null as string | null,
		AudatexUsername: null as string | null,
		CdbOnlinePrp: null as number | null,
		DobropisplatbadleorigPrp: null as number | null,
		DokladnrStylPzn: null as number | null,
		DokladPfxUnqPrp: null as number | null,
		DsbDmsnovinkyTtlMes: null as number | null,
		DsbDmsnovinkyTtpMes: null as number | null,
		DsbLocalTtlMes: null as number | null,
		DsbLocalTtpMes: null as number | null,
		DsbSmsTtlMes: null as number | null,
		DsbSmsTtpMes: null as number | null,
		DsbSystemTtlMes: null as number | null,
		DsbSystemTtpMes: null as number | null,
		EditDat: null as Date | null,
		EditPracId: null as number | null,
		EetczOpravaStartId: null as number | null,
		EetPrp: null as number | null,
		EetTimeout: null as number | null,
		EMailSmtpPrp: null as number | null,
		Emise1MesicInl: null as number | null,
		EmiseMereniNr: null as number | null,
		EmisenextMesicInl: null as number | null,
		EuroStatus: null as number | null,
		FinstatApiKey: null as number | null, // RAW(100 BYTE)
		FinstatPrivateKey: null as number | null, // RAW(100 BYTE)
		FinstatTimeout: null as number | null,
		Firma: null as string | null,
		GdprZakonPlatnost: null as number | null,
		GovregTtlDni: null as number | null,
		HesloDelka: null as number | null,
		HesloKategoriePoc: null as number | null,
		HesloPlatnostDni: null as number | null,
		KalkdrmatprePzn: null as number | null,
		KalkgarpcndPzn: null as number | null,
		KalkgarpcppPzn: null as number | null,
		KalklakdruhprePzn: null as number | null,
		KalkmetodpokynPrp: null as number | null,
		KalknekatalogoveppPrp: null as number | null,
		KalkneorigndPrp: null as number | null,
		KalkneorigppPrp: null as number | null,
		KalkorigtxtndPzn: null as number | null,
		KalkorigtxtppPzn: null as number | null,
		KalkulacePzn: null as number | null,
		KourivInlLmtLex: null as number | null,
		KourivKonLmtLex: null as number | null,
		KurzFixM2: null as number | null,
		KurzstrPar: null as string | null,
		KurzstrSm2pmPar: null as string | null,
		LanguageId: null as number | null,
		M2FixacePrp: null as number | null,
		MdvPnvBlokPrp: null as number | null,
		MenaId1: null as number | null,
		MenaId2: null as number | null,
		MobcliToMi: null as number | null,
		NdakcecheckPzn: null as number | null,
		NvkonfigstylPzn: null as number | null,
		NvnabidkaNrSeq: null as number | null,
		NvnabidkaPldniInl: null as number | null,
		NvnabidkaSmlpodmRtf: null as number | null, // CLOB
		NvobjednDodavtxt: null as string | null,
		NvobjednLegaltxt: null as string | null,
		NvobjednSmlpodmRtf: null as number | null, // CLOB
		NvpoptavkaNrSeq: null as number | null,
		NvpredprotVseobpodmRtf: null as number | null, // CLOB
		Obec: null as string | null,
		ObchPrilezitostNrSeq: null as number | null,
		OrganizaceId: null as number | null,
		OzakazkobjNrSeq: null as number | null,
		OzakDniCheckVpred: null as number | null,
		OzakDniCheckVzad: null as number | null,
		PneusklsmlpodmRtf: null as number | null, // CLOB
		PpDuplCheckPrp: null as number | null,
		PreberpojistprofilPrp: null as number | null,
		PscNr: null as string | null,
		QrCodeRezimPzn: null as number | null,
		RpzvHttpPassw: null as number | null, // RAW(100 BYTE)
		RpzvHttpUsername: null as number | null, // RAW(100 BYTE)
		RpzvWsPassw: null as number | null, // RAW(100 BYTE)
		RpzvWsUsername: null as number | null, // RAW(100 BYTE)
		S2RlCjZobrPrp: null as number | null,
		S2RlLjZobrPrp: null as number | null,
		SilverdatCustomerNr: null as number | null,
		SilverdatOlPrp: null as number | null,
		SilverdatPassw: null as number | null, // RAW(100 BYTE)
		SilverdatUsername: null as string | null,
		SkodahlaspaNrSeq: null as number | null,
		SkoKratitPrp: null as number | null,
		SmBcodePrp: null as boolean | null,
		SmNomslevaPrp: null as number | null,
		SnndCheckPrp: null as number | null,
		SnppCheckPrp: null as number | null,
		Sort2ddSmNd: null as number | null,
		Sort2ddSmPp: null as number | null,
		StatId: null as number | null,
		SysPracovnikId: null as number | null,
		Text: null as string | null,
		ToolbarIcons: null as number | null, // BLOB
		Ulice: null as string | null,
		UovPovBlokPrp: null as number | null,
		VlozitplannepritPrp: null as number | null,
		VlozitplanprestPrp: null as number | null,
		VyhodmechHcvPrp: null as number | null,
		ZakazDelPoznPrp: null as number | null,
		ZakazkoKratitPrp: null as number | null,
		ZlStartpozPrp: null as number | null,
		ZlTiskkontrPrp: null as number | null,
		HasFinstatRight: false,
		AudatexIdentifyVehiclePrp: null as boolean | null,
		PrimaryEmail: null as string | null,
		GstNumber: null as string | null,
		TripodUsername: null as string | null,
		TripodPassword: null as number | null, // RAW(100 BYTE)
		MerchantId: null as string | null,
		HashKey: null as string | null,
		HashIV: null as string | null,
	},
	depTableNames: [],
	depTableSettings: {},
	localState: {},
	extraActions: {},
	extraGetters: {},
	extraMutations: {
	},
	props: {
		mode: null,
	},
});
